import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationSchemeService } from 'src/app/contexts/snapshot/authorization_scheme.service';
import { FlowAuthorizationSchemeModalComponent } from 'src/app/contexts/snapshot/pages/flow/components/modals/flow-authorization-scheme-modal/flow-authorization-scheme-modal.component';
import { ConnectionsService } from 'src/app/contexts/connections/connections.service';
import { ServicesLogosService } from '../../../../core/services/services-logos.service';
import { AuthorizationConfirmSaveComponent } from '../components/authorization-confirm-save/authorization-confirm-save.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-authorization-edit',
  templateUrl: './authorization-edit.component.html',
  styleUrls: ['./authorization-edit.component.scss', './authorization-edit-responsive.component.scss']
})
export class AuthorizationEditComponent {

  model: any = {};
  @ViewChild('allocationField') allocationField: ElementRef<HTMLInputElement>;
  @ViewChild('footer') footerElement: ElementRef;
  @ViewChild('edit') editElement: ElementRef;
  @ViewChild('name') nameElement: ElementRef;
  @Input() is_default: any;

  isScrolled: boolean = false;
  formBuilder: FormBuilder;
  formRange: FormGroup;
  invalid = true;
  state = 'read_only';
  canShowErrorSum = false;

  max = 100;
  min = 0;
  showTicks = false;
  step = 1;
  thumbLabel = false;
  value = 0;

  constructor(
    private dialogRef: MatDialogRef<FlowAuthorizationSchemeModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private connectionsService: ConnectionsService,
    private authorizationSchemeService: AuthorizationSchemeService,
    private ServicesLogosService: ServicesLogosService,
    private translate: TranslateService,
    private router: Router) {
  }

  ngOnInit(): void {

    this.model.connections = [];
    this.model.open = true;
    this.model.partner = this.data.partner;
    this.model.account = this.data.account;

    this.state = this.data.state;

    if (this.state === 'read_only')
      this.model.authorization_scheme = { ...this.data.authorization_scheme };
    else
      this.model.authorization_scheme = {
        name: this.translate.instant('flows.detail.autorization.name'),
        flows: [],
        active_flows: 0,
        steps: [{
          first_service: {},
          second_service: {},
          third_service: {},
          percentage: 100
        }],
      };

    this.initializeData();
  }


  list() {
    this.connectionsService.filter(this.model.partner, this.model.account, ['G'], true).subscribe(response => {
      const connectionsCopy = structuredClone(response.services.filter(p => p.active));
      this.images();
      this.model.connections = connectionsCopy; // Imutável
    });

  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


  images() {
    if (this.model.connections.length > 0) {
      for (let element of this.model.connections) {
        element.image_path = this.ServicesLogosService.getLogo(element);
      }
    }
  }

  processConnection(step, serviceKey) {
    const service = step[serviceKey];
    if (!service || !service.name) return;
    service.image_path = this.ServicesLogosService.getLogo(service);
  }


  updateUrl(service) {
    service.image_path = null;
  }

  onContentScroll(event) {
    if (event.srcElement.scrollTop > 0) {
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }
  }

  ngAfterViewInit() {
  }

  goToService() {
    this.dialogRef.close();
    this.router.navigate([this.model.partner, this.model.account, 'connections']);
  }

  addConnection(step, serviceType: 'first' | 'second' | 'third', connection) {
    this.removeDeleteConnection(step, serviceType);

    Object.assign(step[`${serviceType}_service`], {
      id: connection.service_id,
      version: connection.version_id,
      name: connection.service_name,
      custom_name: connection.custom_name,
      image_path: connection.image_path
    });

    connection.selected = true;

    if (serviceType === 'first') {
      step.percentage = 100;
    }

    ['first', 'second', 'third']
      .filter(type => type !== serviceType)
      .forEach(type => {
        step[`${type}_service`].connections = step[`${type}_service`].connections.filter(
          p => !(p.service_id === connection.service_id && p.version_id === connection.version_id)
        );
      });

    this.valid();
  }


  removeConnection(step: any, serviceType: string) {


    const clonedServices = structuredClone(this.model.connections);
    step[`${serviceType}_service`] = { connections: clonedServices };
    step.percentage = 0;

    this.removeDeleteConnection(step, serviceType);

    this.valid();
  }

  removeDeleteConnection(step: any, serviceType: string) {

    if (step[`${serviceType}_service`]) {
      delete step[`${serviceType}_service`].custom_name;
      delete step[`${serviceType}_service`].image_path;
    }

    if (step[`${serviceType}_service`].connections) {
      step[`${serviceType}_service`].connections.forEach(connection => {
        connection.selected = false;
      });
    }
  }

  editStep(event: any) {
    event.stopPropagation();
  }

  addRow() {

    var copy = structuredClone(this.model.connections);

    this.model.authorization_scheme.steps.push({
      id: this.uuidv4(),
      first_service: {
        connections: [...copy]
      },
      second_service: {
        connections: [...copy]
      },
      third_service: {
        connections: [...copy]
      },
      percentage: 0
    });

    this.valid();
  }

  hasDuplicates(arr) {
    return new Set(arr.map(JSON.stringify)).size !== arr.length;
  }

  valid() {
    this.invalid = true;

    // Calcula a soma dos percentuais
    const sum = this.model.authorization_scheme.steps
      .map(step => parseInt(step.percentage))
      .reduce((a, b) => a + b, 0);

    this.canShowErrorSum = sum !== 100;

    let testStep = 0;

    this.model.authorization_scheme.steps.forEach(step => {
      if (!step.first_service?.id) testStep++;
      if (step.first_service?.id && !step.second_service?.id && step.third_service?.id) testStep++;


      ;
    });

    // Verifica duplicatas
    const duplicates = this.model.authorization_scheme.steps.map(step => {
      return step.first_service ? {
        first_service: { id: step.first_service.id, version: step.first_service.version },
        second_service: { id: step.second_service?.id, version: step.second_service?.version },
        third_service: { id: step.third_service?.id, version: step.third_service?.version }
      } : null;
    });

    if (this.hasDuplicates(duplicates)) testStep++;

    // Validação final
    this.invalid = !(
      this.model.authorization_scheme.steps.every(step => parseInt(step.percentage) !== 0) &&
      sum === 100 &&
      testStep === 0
    );

  }
  save(): Observable<any> {
    let steps = [];

    // Prepara os dados dos steps
    this.model.authorization_scheme.steps.forEach(element => {
      steps.push({
        first_service_id: element.first_service.id,
        first_version_id: element.first_service.version || 0,
        second_service_id: element.second_service ? element.second_service?.id : null,
        second_version_id: element.second_service ? element.second_service?.version : null,
        third_service_id: element.third_service ? element.third_service?.id : null,
        third_version_id: element.third_service ? element.third_service?.version : null,
        percentage: element.percentage
      });
    });

    // Variável que vai segurar o Observable (create ou edit)
    let requestObservable;

    if (this.state === 'add') {
      const create = {
        name: this.model.authorization_scheme.name,
        steps: steps
      };

      // Chama a API para criar
      requestObservable = this.authorizationSchemeService.create(this.model.partner, this.model.account, create);
    } else {
      const edit = {
        id: this.model.authorization_scheme.id,
        name: this.model.authorization_scheme.name,
        steps: steps
      };

      // Chama a API para editar
      requestObservable = this.authorizationSchemeService.edit(this.model.partner, this.model.account, edit);
    }

    // Se o Observable for definido, faz o subscribe
    if (requestObservable) {
      return requestObservable;
      //   .subscribe({
      //     next: (response) => {
      //     
      //       this.dialogRef.close(true);  // Fecha a modal com sucesso
      //     },
    }
  }


  removeRow(as) {
    const index = this.model.authorization_scheme.steps.indexOf(as, 0);
    if (index > -1) {
      this.model.authorization_scheme.steps.splice(index, 1);
    }
    if (this.model.authorization_scheme.steps.length == 1)
      this.model.authorization_scheme.steps[0].percentage = 100;

    this.valid();
  }

  addFlow() {
    this.dialogRef.close(this.model.authorization_scheme);
  }

  clickEditName() {
    setTimeout(() => {
      this.editElement.nativeElement.select();
    }, 100);
  }

  inputNameKeyupEnter(event) {
    this.editStep(event);
    this.nameElement.nativeElement.hidden = false;
  }

  formatPartnerClass(string) {
    return string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  close() {
    this.dialogRef.close();
  }

  getConnections() {
    this.connectionsService.filter(this.model.partner, this.model.account, ['G'], true).subscribe({
      next: (response) => {
        // Criamos uma cópia profunda para garantir a imutabilidade
        this.model.connections = structuredClone(response.services.filter(p => p.active));
        this.images();

        const copy = structuredClone(this.model.connections); // Imutável

        // Inicializa os serviços e garante que objetos não sejam `undefined`
        this.model.authorization_scheme.steps.forEach(step => {
          step.id = this.uuidv4();
          step.first_service = step.first_service || {};
          step.second_service = step.second_service || {};
          step.third_service = step.third_service || {};

          // Criamos cópias profundas individuais para evitar alterações no original
          step.first_service.connections = structuredClone(copy);
          step.second_service.connections = structuredClone(copy);
          step.third_service.connections = structuredClone(copy);
        });

        // Função para definir IDs e versões de um serviço
        const assignServiceDetails = (service) => ({
          id: service?.id || null,
          version: service?.version ?? 0
        });

        // Função para marcar um serviço como adicionado e remover duplicados
        const markAndFilter = (element, serviceKey, markKey, ...otherServices) => {
          const service = element[serviceKey];
          if (!service?.id) return;

          const found = service.connections.find(p => p.service_id === service.id && p.version_id === service.version);
          if (found) found[markKey] = true;

          // Remove este serviço das listas dos outros serviços
          otherServices.forEach(other => {
            if (other.connections) {
              other.connections = other.connections.filter(p => !(p.service_id === service.id && p.version_id === service.version));
            }
          });
        };

        this.model.authorization_scheme.steps.forEach(element => {
          Object.assign(element, {
            first_service_id: assignServiceDetails(element.first_service).id,
            first_version_id: assignServiceDetails(element.first_service).version,
            second_service_id: assignServiceDetails(element.second_service).id,
            second_version_id: assignServiceDetails(element.second_service).version,
            third_service_id: assignServiceDetails(element.third_service).id,
            third_version_id: assignServiceDetails(element.third_service).version
          });

          markAndFilter(element, 'first_service', 'selected', element.second_service, element.third_service);
          markAndFilter(element, 'second_service', 'selected', element.first_service, element.third_service);
          markAndFilter(element, 'third_service', 'selected', element.first_service, element.second_service);
        });

        this.valid();
      },
      error: (error) => {
        if (error.result?.length > 0) {
          error.result.forEach(element => {
            this.toastr.error(element.message);
          });
        }
      }
    });
  }


  edit() {
    this.state = 'editing';
  }

  initializeData() {

    // if (this.state == 'read_only') {
    //   this.authorizationSchemeService.get(this.model.partner, this.model.account, this.data.authorization_scheme_id)
    //     .subscribe({
    //       next: (response) => {

    //         this.model.authorization_scheme = {
    //           ...this.model.authorization_scheme,
    //           flows: response.authorization_scheme?.flows || [],
    //           active_flows: response.authorization_scheme?.active_flows || 0,
    //         };



    //       },
    //       error: (err) => console.error('Erro:', err),
    //     });
    // }

    this.model.has_test_ab = this.model.authorization_scheme?.flows?.some(p => p.test_ab_count > 1);

    for (const step of this.model.authorization_scheme.steps) {
      step.id = this.uuidv4();
      this.processConnection(step, 'first_service');
      this.processConnection(step, 'second_service');
      this.processConnection(step, 'third_service');
    }


    this.getConnections();

  }

  confirm() {
    const dialog = this.dialog.open(AuthorizationConfirmSaveComponent, {
      width: '990px !important',
      autoFocus: true,
      data: {
        partner: this.model.partner,
        account: this.model.account,
        parent: this,
        state: this.state,
        name: this.model.authorization_scheme.name
      }
    });

    dialog.afterClosed().subscribe((result) => {

      if (result.reload) {
        this.state = 'read_only';
        this.initializeData();
      } else {
        this.dialogRef.close(result);
      }

    });
  }
}
